import { render, staticRenderFns } from "./VIPKalameetingSetup.vue?vue&type=template&id=5801b75c&scoped=true&"
import script from "./VIPKalameetingSetup.vue?vue&type=script&lang=js&"
export * from "./VIPKalameetingSetup.vue?vue&type=script&lang=js&"
import style0 from "./VIPKalameetingSetup.vue?vue&type=style&index=0&id=5801b75c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5801b75c",
  null
  
)

export default component.exports